/** @file A topology action as a gesture: refused in Animate mode, else its batch commits on release. */
import type { ToolGesture } from '../../panels/viewport/viewportTypes';
import { meshAction, type MeshActionId } from './meshAction';
import type { MeshScene } from './meshScene';
import { pendingOf } from './pendingOf';
import { selectVertices } from './selectVertices';

/** null (with a notice) in Animate mode or when the action does not apply; release selects and returns the batch. */
export function meshActionGesture(s: MeshScene, id: MeshActionId, selected: readonly number[]): ToolGesture | null {
  const { ctx } = s;
  if (ctx.tool.mode === 'animate') {
    ctx.notify({ kind: 'info', key: 'tools.editMesh.setupOnly' });
    return null;
  }
  const out = meshAction(id, ctx.doc, s.target, selected);
  if ('hint' in out) {
    ctx.notify({ kind: 'info', key: out.hint });
    return null;
  }
  return {
    move: () => undefined,
    release() {
      selectVertices(s.target.attachment, out.select, 'replace');
      return pendingOf(out.calls);
    },
    cancel: () => undefined,
  };
}
